import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux/";
import { Outlet } from "react-router-dom";
import { PAGES } from "../../../constants";
import { getAppStatus } from "../../../redux/slice/staff/staffSlice";

const RedirectStaffOnboarding = () => {
  const { app_id, staff_records, pages } = useSelector((state) => state.staff);
  const { previousPage, nextPage } = pages;
  // const PAGE_SLUG = {previousPage: pages.nextPage, nextPage: pages.nextPage}
  const dispatch = useDispatch();

  // if current state has app_id, fetch app status
  useEffect(() => {
    if (app_id) {
      dispatch(getAppStatus(app_id));
    }
  }, [staff_records]);
  return (
    <Outlet
      context={{ previousPage: PAGES[previousPage], nextPage: PAGES[nextPage] }}
    />
  );
};

export default RedirectStaffOnboarding;
